import { createContext } from 'react';

const MobileContext = createContext(false);

export default MobileContext;
